import { useProduct } from "@shopify/hydrogen-react";
import type { ProductOption } from "@shopify/hydrogen-react/storefront-api-types";
import { Button } from "atoms";
import { useSearchParams } from "react-router-dom";

function ProductOptions() {
  const { product, selectedOptions = {}, setSelectedOption } = useProduct();
  const [searchParams, setSearchParams] = useSearchParams();

  if (!product?.options?.length) {
    return null;
  }

  const onClick: React.MouseEventHandler<HTMLButtonElement> = (e) => {
    const { name, value } = e.currentTarget.dataset;
    if (!name || !value) {
      return;
    }
    setSelectedOption(name, value);
    const newParams = new URLSearchParams(searchParams);
    newParams.set(name, value);
    setSearchParams(newParams, { replace: true });
  };

  // TODO: Add single valued options to search params too so we can select the right variant
  // const [single, multiple] = product.options.filter(isOption).reduce((acc, cur) => {
  const options = product.options.filter(isOption).reduce(
    (acc, cur) => {
      const index = Number(cur.values.length > 1);
      acc[index].push(cur);
      return acc;
    },
    [[], []] as [ProductOption[], ProductOption[]],
  );
  const multiple = options[1];

  return !multiple.length ? null : (
    <div>
      {multiple.map(({ name, values }) =>
        !values.length ? null : (
          <div key={name}>
            <h3>{name}</h3>

            <ul>
              {values.map((value) => (
                <li key={value}>
                  {selectedOptions[name] === value ? (
                    <strong>{value}</strong>
                  ) : (
                    <Button
                      onClick={onClick}
                      data-name={name}
                      data-value={value}
                      variant="blank"
                    >
                      {value}
                    </Button>
                  )}
                </li>
              ))}
            </ul>
          </div>
        ),
      )}
    </div>
  );
}

const isOption = (option: unknown): option is ProductOption =>
  !!option &&
  typeof option === "object" &&
  "name" in option &&
  typeof option.name === "string" &&
  "values" in option &&
  Array.isArray(option.values);

export { ProductOptions };
